
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWifiBadGoogle as ObiWifiBadGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-wifi-bad-google.js';
 
 
 

 
 export const ObiWifiBadGoogle = createComponent({
   react: React,
   tagName: 'obi-wifi-bad-google',
   elementClass: ObiWifiBadGoogleElement,
   events: {
     
   }
  });
 
 